import { useLayoutEffect as e, useEffect as f } from "react";
const t = typeof document != "undefined" ? e : f;
export {
  t as u
};
